import { toast } from 'react-toastify';

export const handleApiError = (error) => {
  if (error.response) {
    const { status, data } = error.response;
    const message = data.error || 'An error occurred';
    const errors = data.errors || [];
    
    // Show error toast for user feedback
    toast.error(message);

    switch (status) {
      case 401:
        // Handle unauthorized - redirect to login
        if (!window.location.pathname.includes('/login')) {
          window.location.href = '/login';
        }
        break;
      case 403:
        throw new Error('You do not have permission to perform this action');
      case 404:
        throw new Error('The requested resource was not found');
      case 422:
        throw new Error('Validation failed: ' + errors.join(', '));
      default:
        throw new Error(message);
    }
  } else if (error.request) {
    // Network error
    const message = 'Network error - please check your connection';
   // toast.error(message);
    throw new Error(message);
  } else {
    // Something else happened
    const message = 'An unexpected error occurred';
    //toast.error(message);
    throw new Error(message);
  }
}; 